// Lore: the /lore page's sections in five sub-tabs. The text lives only in client/lore.html; this screen fetches it
// once and shows its sections, so the page and the menu can't drift apart.
import { subtabs, empty, Ctx, Screen } from './kit';

const SUBS: [string, string, string[]][] = [
  ['city', 'City', ['power', 'quake']],
  ['crews', 'Crews', ['oni', 'kaminari']],
  ['benikage', 'Benikage', ['benikage']],
  ['kanemori', 'Kanemori', ['kanemori']],
  ['bosses', 'Bosses', ['bosses']],
];

let sections: Record<string, string> | null = null, lede = '', failed = false, loading = false;

function load() {
  if (loading) return;
  loading = true;
  fetch('/lore').then(r => { if (!r.ok) throw new Error(String(r.status)); return r.text(); }).then(html => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    lede = doc.querySelector('.lede')?.textContent ?? '';
    sections = {};
    for (const s of doc.querySelectorAll('section[id]')) {
      s.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));
      sections[s.id] = s.innerHTML;
    }
  }).catch(() => { failed = true; });
}

export function lore(m: Ctx): Screen {
  const cur = SUBS.find(s => s[0] === m.view.sub) ?? SUBS[0];
  if (!sections && !failed) load();
  const body = failed ? empty('The lore page could not be loaded. <a href="/lore" target="_blank" rel="noopener">Open it in a new tab</a>.')
    : !sections ? empty('Loading…')
    : `${cur[0] === 'city' && lede ? `<p class="mn-lore-lede">${lede}</p>` : ''}<div class="mn-lore lore-${cur[0]}">${cur[2].map(id => `<section>${sections![id] ?? ''}</section>`).join('')}</div>`;
  return {
    title: 'Lore',
    subs: subtabs(SUBS.map(([id, label]) => [id, label] as [string, string]), cur[0]),
    body,
    foot: 'Shinjuku, 2089 · <a href="/lore" target="_blank" rel="noopener">Full lore page</a>',
  };
}
